module.exports = __webpack_public_path__ + "img/InterContinental.aeec29c1.jpg";